// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"193341de","239":"decc9f52","667":"cda1efa0","977":"8fc4843a"}[chunkId] + ".chunk.js";
};